import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Text } from '@cowbell/ui';
import styles from './PaneHeader.module.css';
import type_ from './settingsType.module.css';

export interface PaneHeaderProps {
  readonly icon: IconDefinition;
  readonly title: string;
  readonly subtitle: string;
}

/** Dark circular icon tile, title and one-line subtitle — the pattern every
 *  settings section opens with. */
export function PaneHeader({ icon, title, subtitle }: PaneHeaderProps) {
  return (
    <div className={styles.header}>
      <div className={styles.iconTile} aria-hidden="true">
        <FontAwesomeIcon icon={icon} />
      </div>
      <div className={styles.copy}>
        <Text className={type_.paneTitle}>{title}</Text>
        <Text className={type_.subtitle}>{subtitle}</Text>
      </div>
    </div>
  );
}
